import { normalizeESignStatuses } from 'features/Procedure/components/e-sign-button/e-sign-chip.utils'
import type { ESignFormName, PatientWithEncounters } from './procedure-api.type'

// Returns a new patients list with the given form flagged as signed on one encounter.
export const markEncounterFormSigned = (
  patients: PatientWithEncounters[],
  patientId: number,
  encounterUid: string,
  formName: ESignFormName,
): PatientWithEncounters[] => {
  return patients.map((entry) => {
    if (entry.patient.patient_id !== patientId) return entry

    return {
      ...entry,
      encounters: entry.encounters.map((encounter) => {
        if (encounter.encounter_uuid !== encounterUid) return encounter
        return {
          ...encounter,
          esign_statuses: { ...normalizeESignStatuses(encounter.esign_statuses), [formName]: 1 },
        }
      }),
    }
  })
}

// True when the cached list already holds this patient/encounter pair.
export const hasPatientEncounter = (
  patients: PatientWithEncounters[],
  patientId: number,
  encounterUid: string,
): boolean => {
  const entry = patients.find((item) => item.patient.patient_id === patientId)
  if (!entry) return false
  return entry.encounters.some((encounter) => encounter.encounter_uuid === encounterUid)
}
